/**
 * Represents the fiscal data choice for a single brand during onboarding.
 * Each brand can either reuse the store's registered fiscal data or provide custom ones.
 */
export type BrandFiscalChoice = Readonly<{
  brandUuid: string;
  brandName: string;
  useRegisteredData: boolean;
  customLegalName: string;
  customRfc: string;
  customFiscalAddress: string;
}>;

/**
 * Creates a validated BrandFiscalChoice value object.
 *
 * @param params - Raw values from the form
 * @returns Frozen BrandFiscalChoice
 */
export const createBrandFiscalChoice = (params: {
  brandUuid: string;
  brandName: string;
  useRegisteredData: boolean;
  customLegalName?: string;
  customRfc?: string;
  customFiscalAddress?: string;
}): BrandFiscalChoice => {
  return Object.freeze({
    brandUuid: params.brandUuid,
    brandName: params.brandName,
    useRegisteredData: params.useRegisteredData,
    customLegalName: params.customLegalName?.trim() ?? '',
    customRfc: params.customRfc?.trim().toUpperCase() ?? '',
    customFiscalAddress: params.customFiscalAddress?.trim() ?? '',
  });
};
